import * as Yup from "yup";
import { noEmojiTest } from "../../validations";

export const benefitsAndAllowancesSchema = Yup.object().shape({
  paymentSettings: Yup.object().shape({
    payPeriodId: Yup.string().required("Pay date is required"),
    benefitType: Yup.string().required("Benefit type is required"),
    notes: noEmojiTest,
    fuelType: Yup.string().when("benefitType", {
      is: "Car or Commuter Allowance",
      then: (schema) => schema.required("Fuel type is required"),
    }),
  }),
});
